<mat-toolbar>
  <kt-navigator></kt-navigator>

  <span class="delimiter"></span>

  <kt-topbar-dynamic-items></kt-topbar-dynamic-items>

</mat-toolbar>
